import { assetsPath } from "../../../utils";
import BPA1 from "../../../data/PhuketSkypark/sitePlan/svg/a/1";
import BPA2 from "../../../data/PhuketSkypark/sitePlan/svg/a/2";
import BPA3 from "../../../data/PhuketSkypark/sitePlan/svg/a/3";
import BPA4 from "../../../data/PhuketSkypark/sitePlan/svg/a/4";
import BPA5 from "../../../data/PhuketSkypark/sitePlan/svg/a/5";
import BPA6 from "../../../data/PhuketSkypark/sitePlan/svg/a/6";
import BPA7 from "../../../data/PhuketSkypark/sitePlan/svg/a/7";
// import BPA8 from "../../../data/PhuketSkypark/sitePlan/svg/a/8";

import BPB1 from "../../../data/PhuketSkypark/sitePlan/svg/b/1";
import BPB2 from "../../../data/PhuketSkypark/sitePlan/svg/b/2";
import BPB3 from "../../../data/PhuketSkypark/sitePlan/svg/b/3";
import BPB4 from "../../../data/PhuketSkypark/sitePlan/svg/b/4";
import BPB5 from "../../../data/PhuketSkypark/sitePlan/svg/b/5";
import BPB6 from "../../../data/PhuketSkypark/sitePlan/svg/b/6";
import BPB7 from "../../../data/PhuketSkypark/sitePlan/svg/b/7";
import BPB8 from "../../../data/PhuketSkypark/sitePlan/svg/b/8";

import BPC1 from "../../../data/PhuketSkypark/sitePlan/svg/c/1";
import BPC2 from "../../../data/PhuketSkypark/sitePlan/svg/c/2";
import BPC3 from "../../../data/PhuketSkypark/sitePlan/svg/c/3";
import BPC4 from "../../../data/PhuketSkypark/sitePlan/svg/c/4";
import BPC5 from "../../../data/PhuketSkypark/sitePlan/svg/c/5";
import BPC6 from "../../../data/PhuketSkypark/sitePlan/svg/c/6";
import BPC7 from "../../../data/PhuketSkypark/sitePlan/svg/c/7";
import BPC8 from "../../../data/PhuketSkypark/sitePlan/svg/c/8";

import Siteplan from "../../../data/PhuketSkypark/sitePlan/svg/a/siteplan";

import Comming from "../../../data/PhuketSkypark/sitePlan/svg/c/coming-soon";

const maps = `${assetsPath("phuket-skypark")}/images/site-plan/image.jpg`;

const subType = [
  {
    value: "all",
    title: {
      en: "ALL",
      ru: "Все",
      cn: "全部",
    },
  },
  {
    value: "studio",
    title: {
      en: "Studio",
      ru: "Блок",
      cn: "一室公寓",
    },
  },
  {
    value: "one-bedroom",
    title: {
      en: "One-bedroom",
      ru: "Одна спальня",
      cn: "一卧室套房",
    },
  },
  {
    value: "two-bedroom",
    title: {
      en: "Two-bedroom",
      ru: "Две спальни",
      cn: "两卧室套房",
    },
  },
];
const subTabs = [
  {
    value: "all",
    title: {
      en: "All",
      ru: "Все",
      cn: "全部",
    },
    showModal: false,
    img: Siteplan,
  },
  {
    value: "a",
    title: {
      en: "Block A",
      ru: "Блок A",
      cn: "A栋",
    },
    showModal: false,
    img: BPA1,
  },
  {
    value: "b",
    title: {
      en: "Block B",
      ru: "Блок B",
      cn: "B栋",
    },
    showModal: false,
    img: BPB1,
  },
  {
    value: "c",
    title: {
      en: "Block C",
      ru: "Блок C",
      cn: "C栋",
    },
    showModal: false,
    img: Comming,
  },
];

const type = [
  {
    value: "1st",
    title: {
      en: "1st Floor",
      ru: "1-й этаж",
      cn: "1楼",
    },
    floorPlan: {
      a: BPA1,
      b: Comming,
      c: Comming,
    },
    buttons: subType,
  },
  {
    value: "2nd",
    title: {
      en: "2nd Floor",
      ru: "2-й этаж",
      cn: "2楼",
    },
    floorPlan: {
      a: BPA2,
      b: Comming,
      c: Comming,
    },
    buttons: subType,
  },
  {
    value: "3rd",
    title: {
      en: "3rd Floor",
      ru: "3-й этаж",
      cn: "3楼",
    },
    floorPlan: {
      a: BPA3,
      b: Comming,
      c: Comming,
    },
    buttons: subType,
  },
  {
    value: "4th",
    title: {
      en: "4th Floor",
      ru: "4-й этаж",
      cn: "4楼",
    },
    floorPlan: {
      a: BPA4,
      b: Comming,
      c: Comming,
    },
    buttons: subType,
  },
  {
    value: "5th",
    title: {
      en: "5th Floor",
      ru: "5-й этаж",
      cn: "5楼",
    },
    floorPlan: {
      a: BPA5,
      b: Comming,
      c: Comming,
    },
    buttons: subType,
  },
  {
    value: "6th",
    title: {
      en: "6th Floor",
      ru: "6-й этаж",
      cn: "6楼",
    },
    floorPlan: {
      a: BPA6,
      b: Comming,
      c: Comming,
    },
    buttons: subType,
  },
  {
    value: "7th",
    title: {
      en: "7th Floor",
      ru: "7-й этаж",
      cn: "7楼",
    },
    floorPlan: {
      a: BPA7,
      b: Comming,
      c: Comming,
    },
    buttons: subType,
  },
  // {
  //   value: "8th",
  //   title: {
  //     en: "Rooftop Floor",
  //     ru: "Крыша",
  //     cn: "天台",
  //   },
  //   floorPlan: {
  //     a: BPA8,
  //     b: BPB8,
  //     c: BPC8,
  //   },
  //   buttons: subType,
  // },
];
const descriptions = [
  {
    value: "studio",
    title: {
      en:
        "The intelligently-designed 28 sqm studio apartments offer all the modern conveniences to cater to long-term residents and visiting guests.",
      cn:
        "智能设计的28平方米一卧开间可提供所有现代化的便利设施，以满足长住业主和来访客人的需求。",
      ru:
        "Умно спроектированные квартиры-студии площадью 28 кв.м предлагают все современные удобства как для постоянных жителей, так и гостей.",
    },
  },
  {
    value: "one-bedroom",
    title: {
      en:
        "The one-bedroom apartments at Skypark offer between 30 to 39 sqm of calming space to relax and recharge in the comfortable living area and separate master bedroom.",
      cn:
        "海天苑的一卧套房为住客提供30至39平方米的安静空间，可在舒适的生活区和独立的主卧室充分放松和休整",
      ru:
        "Квартиры с одной спальней в Skypark площадью от 30 до 39 кв.м предлагают пространства для отдыха и перезарядки в уютной гостиной и отдельной главной спальне.",
    },
  },
  {
    value: "two-bedroom",
    title: {
      en:
        "The spacious homes at Skypark range from 40 to 60 sqm and feature two separate bedrooms that can also be opened up to form one flowing space with the living room to suit moments of live, work, and rest.",
      cn:
        "海天苑的宽敞二卧室套房面积从40平方米到60平方米不等，配有两个独立的卧室，也可以与客厅打通，形成一个流动空间，以适应生活、工作和休息的需要。",
      ru:
        "Просторные квартиры в Skypark варьируются от 40 до 60 кв.м и имеют две отдельные спальни и гостиную, для различных моментов жизни, работы и отдыха.",
    },
  },
];

// const type = [
//   {
//     value: 'all',
//     title: {
//       en: 'ALL',
//       ru: 'ALL',
//       cn: 'ALL',
//     },
//   },
//   {
//     value: 'studio',
//     title: {
//       en: 'Studio',
//       ru: 'Studio',
//       cn: 'Studio',
//     },
//   },
//   {
//     value: 'one-bedroom',
//     title: {
//       en: 'One-bedroom',
//       ru: 'One-bedroom',
//       cn: 'One-bedroom',
//     },
//   },
//   {
//     value: 'two-bedroom',
//     title: {
//       en: 'Two-bedroom',
//       ru: 'Two-bedroom',
//       cn: 'Two-bedroom',
//     },
//   },
// ];

export default {
  maps,
  type,
  subTabs,
  descriptions,
};



// WEBPACK FOOTER //
// ./src/data/PhuketSkypark/sitePlan/index.js